import { render, staticRenderFns } from "./WorkGroupShowScreen.vue?vue&type=template&id=f922babe&"
import script from "./WorkGroupShowScreen.vue?vue&type=script&lang=js&"
export * from "./WorkGroupShowScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports